module.exports = __webpack_public_path__ + "img/user.471a1ad3.png";